export {WsBadge} from './ws-badge.js';
export type {WsBadgeTone} from './ws-badge.js';
